var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function SearchIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.3922 19.978C21.781 20.3668 21.7823 20.9958 21.3891 21.3891C20.9986 21.7796 20.3674 21.7816 19.978 21.3922L14.5491 15.9633C13.2873 16.9274 11.7105 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 11.7105 16.9274 13.2873 15.9633 14.5491L21.3922 19.978ZM10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5Z", fill: "" })));
}
export var SearchIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: SearchIconInner }, props))); };
//# sourceMappingURL=SearchIcon.js.map